module.exports = __webpack_public_path__ + "static/media/chahua.33b2e721.svg";